module.exports = __webpack_public_path__ + "static/character--pluggy-tip@3x.72f92bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--pluggy-tip@3x.png
// module id = 1275
// module chunks = 168707334958949